import environmentConfig from './utils/configs';

// Get version from environment or fallback to application version
const appVersion = import.meta.env.VITE_SENTRY_RELEASE || '0.0.0';
const config = {
    EVENT_NAMESPACE: 'beststart-centre.banking-web',
    audience: 'beststart-centre.banking-web',
    gitBranch: null,
    version: appVersion,
    namespace: 'beststart-centre.banking-web',
    tag: 'beststart-centre.banking-web',
    env: import.meta.env.MODE,
    paymintApiUrl: environmentConfig.paymintApiUrl,
    LogLevel: environmentConfig.LogLevel || 0, // Default to Error if not set
    sampleRate: environmentConfig.sampleRate || 0, // Default to 0 if not set
    defaultChildId: "999999999",
    sentry: {
        dsn: "https://b5211a0df05728bb829cac4453b3ae8f@o4509346579677184.ingest.de.sentry.io/4510580882210896",
    },
    authentication: {
        clientId:   environmentConfig.clientId,
        authority: environmentConfig.authority,
        redirectUri: window.location.hostname === "localhost.lambdatest.com" ? 'https://localhost.lambdatest.com:50329/login' : `${window.location.origin}/login`,
    },

};
export default config;